import LoyaltyCircle from './LoyaltyCircle';
import './LoyaltyCircle.css';

export default LoyaltyCircle;



// WEBPACK FOOTER //
// ./src/components/LoyaltyCircle/index.js